import * as amplitude from '@amplitude/analytics-browser';
import Cookies from 'universal-cookie';

let initialized = false;

// Initializes the Amplitude SDK once per tab. Safe to call on every event and on
// every route change - returns false while the amplitudeID cookie is missing
// (i.e. before login) so a later call can retry.
export const initAmplitude = () => {
  if (initialized) return true;

  const cookies = new Cookies();
  const amplitudeID = cookies.get("amplitudeID");
  if (!amplitudeID) return false;

  amplitude.init(amplitudeID, {defaultTracking: true});
  initialized = true;

  const userId = cookies.get('name');
  if (userId) {
    amplitude.setUserId(userId);
  }

  return true;
};

const Events = (value, eventProperties = {}) => {
  if (!initAmplitude()) {
    console.warn('Amplitude ID not found');
    return;
  }

  const cookies = new Cookies();
  const userId = cookies.get('name');

  const getSessionId = () => {
    const previousTimestamp = cookies.get('sessionId', { path: '/' });
    const currentTimestamp = Date.now();

    let difference = Math.round((currentTimestamp - previousTimestamp) / 1000);
    if (difference >= 1800) {
      cookies.set('sessionId', currentTimestamp, { path: '/' });
    }
    return cookies.get('sessionId', { path: '/' });
  };

  // Log the event to Amplitude
  amplitude.track(value, {
    event_type: value,
    user_id: userId,
    session_id: getSessionId(),
    event_properties: {
      ...eventProperties
    },
  });
};

export default Events;
